import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface GaugeChartProps {
  value: number;
  max?: number;
  title?: string;
  height?: number;
  color?: string;
  threshold?: { warning: number; critical: number };
}

export const GaugeChart: React.FC<GaugeChartProps> = ({
  value,
  max = 100,
  title,
  height = 200,
  color,
  threshold,
}) => {
  const percentage = Math.min((value / max) * 100, 100);
  const remaining = 100 - percentage;

  const getColor = () => {
    if (color) return color;
    if (threshold) {
      if (value < threshold.critical) return '#ff4444';
      if (value < threshold.warning) return '#ffaa00';
    }
    if (percentage >= 70) return '#00C851';
    if (percentage >= 40) return '#ffbb33';
    return '#ff4444';
  };

  const data = [
    { name: 'Value', value: percentage },
    { name: 'Remaining', value: remaining },
  ];

  return (
    <div style={{ width: '100%', height, textAlign: 'center' }}>
      {title && <h3 style={{ marginBottom: '16px' }}>{title}</h3>}
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
          >
            <Cell fill={getColor()} />
            <Cell fill="#e0e0e0" />
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <div
        style={{
          marginTop: '-120px',
          fontSize: '24px',
          fontWeight: 'bold',
          color: getColor(),
        }}
      >
        {value.toFixed(1)}
      </div>
      {max !== 100 && (
        <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
          / {max}
        </div>
      )}
    </div>
  );
};
